export default {"src":"/_next/static/media/coverage-icon.d7c24ccb.svg","height":358,"width":357,"blurWidth":0,"blurHeight":0};